<template>
    <div id="posta-guvercini-channel-detail">
        <AppBreadCrumb
            :paths="[{ title: $t('whatsappChannel.postaGuverciniDetail') }]"
            :select="true"
            class="visitor-detail-bread-crumb"
        >
        </AppBreadCrumb>
        <div class="wrapper">
            <div class="toolbar">
                <div class="left">
                    <IconButton :on-click="() => $router.push('/integrations/sms/posta-guvercini')">
                        <span class="material-icons"> chevron_left </span>
                    </IconButton>
                    <div class="icon-container">
                        <img src="/static/img/posta-guvercini-logo.png" />
                    </div>
                    <div class="name">Posta Güvercini</div>
                </div>
            </div>
            <div class="channel-content">
                <div class="left">
                    <ChannelMenu v-model="currentTab" />
                </div>
                <div class="page-content" v-if="channel">
                    <div v-if="currentTab === PostaGuverciniChannelMenuTypes.CHANNEL.id">
                        <UpdateDetail v-model="channel" :credit="credit" />
                    </div>
                    <div v-if="currentTab === PostaGuverciniChannelMenuTypes.SEND_SMS.id">
                        <SendSmsPostaGuvercini :channel="channel" :credit="credit" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import AppBreadCrumb from "../../../../../../components/common/AppBreadCrumb.vue";
import IconButton from "../../../../Settings/components/IconButton.vue";
import PostaGuverciniChannelMenuTypes from "./PostaGuverciniChannelMenuTypes";
import UpdateDetail from "./UpdateDetail.vue";
import SendSmsPostaGuvercini from "./SendSmsPostaGuvercini.vue";
import { mapActions, mapState } from "vuex";
import ChannelMenu from "./ChannelMenu.vue";
import _ from "lodash";

export default {
    name: "PostaGuverciniChannelDetail",
    components: {
        ChannelMenu,
        IconButton,
        AppBreadCrumb,
        UpdateDetail,
        SendSmsPostaGuvercini,
    },
    data() {
        const path = (_.last(this.$route.path.split("/")) || "detail").toLowerCase().trim();
        const selected = Object.values(PostaGuverciniChannelMenuTypes).find(
            (x) => x.path.toLowerCase() === path
        );
        return {
            currentTab: selected ? selected.id : "detail",
            PostaGuverciniChannelMenuTypes,
            channel: null,
            selectedChannelId: this.$route.params.id,
            credit: 0,
        };
    },
    computed: {
        ...mapState({
            channels: (state) => state.channel.channels.filter((x) => x.type === "sms-posta-guvercini"),
        }),
    },
    methods: {
        ...mapActions({
            listChannels: "channel/listChannels",
            getPostaGuverciniChannelCredit: "channel/getPostaGuverciniChannelCredit",
        }),
    },
    mounted() {
        this.getPostaGuverciniChannelCredit(this.selectedChannelId)
            .then((data) => {
                this.credit = data;
            })
            .catch(() => {});
        this.listChannels().then((channels) => {
            this.channel = channels.find((x) => x._id === this.selectedChannelId);
        });
    },
    watch: {
        currentTab(value) {
            const selected = Object.values(PostaGuverciniChannelMenuTypes).find((x) => x.id === value);
            if (selected) {
                this.$router.push(
                    `/integrations/sms/posta-guvercini/${this.$route.params.id}/detail/${selected.path}`
                );
            }
        },
    },
};
</script>
<style scoped lang="scss">
#posta-guvercini-channel-detail {
    display: flex;
    flex-direction: column;
    background: var(--color-bg-default);
    position: relative;
    width: 100%;
    height: 100%;

    .wrapper {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;

        .toolbar {
            padding: 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 50px;
            border: 1px solid var(--color-border-default);

            .left {
                display: flex;
                align-items: center;
                gap: 5px;

                .name {
                    font-size: 18px;
                    font-weight: 700;
                }

                .icon-container {
                    width: 100px;
                    height: 30px;
                    display: flex;
                    margin: 0 auto;
                    align-items: center;
                    justify-content: center;
                    border-radius: 6px;
                    overflow: hidden;
                    padding: 10px;
                }
            }
        }

        .channel-content {
            display: flex;
            height: 100%;

            .left {
                width: 275px;
                height: 100%;
            }

            .page-content {
                width: calc(100% - 275px);
                height: 100%;
            }
        }
    }
}
</style>
